import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import usePopOver from "@/hooks/use-popover";
import { AccountType, BankAccount } from "@/interfaces/talk2pay.iterfaces";
import { BankAccountDialogMessages } from "@/messages/platforms/talk2PayHome/bank-account-dialog.messages";

import Popover from "../bankAccountPopover";

interface Props {
  account: BankAccount;
  index: number;
  messages: BankAccountDialogMessages;
  onRemove: (account: BankAccount) => void;
  openDialog: (isEditing: boolean, account?: BankAccount) => void;
}

export function BankAccountTableRow({ messages, account, index, onRemove, openDialog }: Props) {
  const { openPopover, anchorEl, closePopover, isOpen, selected } = usePopOver<BankAccount>();

  const formatAccountType = (type: AccountType) => {
    switch (type) {
      case AccountType.CORRENTE:
        return messages.accountTypeCheckingLabel;
      case AccountType.POUPANCA:
        return messages.accountTypeSavingsLabel;
      default:
        return type;
    }
  };

  return (
    <TableRow index={index}>
      <TableCell>{account.name}</TableCell>
      <TableCell>
        {account.bankCode}
        {" -"} {account.bankName}
      </TableCell>
      <TableCell>{formatAccountType(account.type)}</TableCell>
      <TableCell>
        {account.agency}
        {account.agencyDigit ? `-${account.agencyDigit}` : ""}
      </TableCell>
      <TableCell>
        {account.number}
        {account.digit ? `-${account.digit}` : ""}
      </TableCell>
      <TableCell>
        <IconButton onClick={(e) => openPopover(e, account)}>
          <MoreHorizIcon />
        </IconButton>
        {selected && (
          <Popover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selected={selected}
            onRemove={onRemove}
            openDialog={openDialog}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
